module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-304-retro.4498b8ec.jpg";